import { useTranslation } from "react-i18next";

import FlexTable from "../../../ui/components/FlexTable/FlexTable";
import ProgressLabel from "../../../ui/components/ProgressLabel/ProgressLabel";

export default function FileUploadTable({ files, progress, ...props }) {
	const { t } = useTranslation();

	const getPercent = (file) => {
		return (progress?.[file.name] || 0) * 100;
	};

	const getStatus = (percent) => {
		if (percent === 0) {
			return {
				text: t("pending", "Pending"),
				color: "grey",
			};
		}

		if (percent === 100) {
			return {
				text: t("uploaded", "Uploaded"),
				color: "green",
			};
		}

		return {
			text: t("uploading", "Uploading"),
			color: "blue",
		};
	};

	const columns = [
		{
			id: "name",
			flex: 1,
		},
		{
			id: "status",
			Cell: ({ row }) => {
				const percent = getPercent(row.original);
				const { text, color } = getStatus(percent);

				return (
					<ProgressLabel active={percent > 0 && percent < 100} color={color} percent={percent}>
						{text}
					</ProgressLabel>
				);
			},
		},
	];

	return <FlexTable data={files} columns={columns} getRowKey={(row) => row.name} {...props} />;
}
